import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '@env/app-config';
import { ApiResponse } from '@models/common/api-response.model';
import { CelebrationTriggerDTO } from '../models/celebration.model';

@Injectable({ providedIn: 'root' })
export class CelebrationsService {
  private http   = inject(HttpClient);
  private apiUrl = `${AppConfig.apiUrl}/api/nexus/celebrations`;

  settings(companyId: number): Observable<CelebrationTriggerDTO[]> {
    return this.http.get<CelebrationTriggerDTO[]>(`${this.apiUrl}/settings`, { params: { companyId } });
  }

  updateSetting(body: Partial<CelebrationTriggerDTO>, companyId: number): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${this.apiUrl}/settings`, body, { params: { companyId } });
  }

  teamSettings(teamId: number, companyId: number): Observable<CelebrationTriggerDTO[]> {
    return this.http.get<CelebrationTriggerDTO[]>(`${this.apiUrl}/settings/team/${teamId}`, { params: { companyId } });
  }

  updateTeamSetting(teamId: number, body: Partial<CelebrationTriggerDTO>, companyId: number): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${this.apiUrl}/settings/team/${teamId}`, body, { params: { companyId } });
  }

  deleteTeamSetting(teamId: number, eventType: string, companyId: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${this.apiUrl}/settings/team/${teamId}/${eventType}`, { params: { companyId } });
  }

  myPreference(companyId: number): Observable<{ celebrationsEnabled: boolean }> {
    return this.http.get<{ celebrationsEnabled: boolean }>(`${this.apiUrl}/my-preference`, { params: { companyId } });
  }

  setMyPreference(celebrationsEnabled: boolean, companyId: number): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`${this.apiUrl}/my-preference`, { celebrationsEnabled }, { params: { companyId } });
  }
}
